// extracted by mini-css-extract-plugin
module.exports = {"content":"Content-module--content--3p512","content__body":"Content-module--content__body--2TrQ-","content__title":"Content-module--content__title--2BDW9"};